module.exports = __webpack_public_path__ + "assets/img/btn-view-f0bb910c.png";